import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

const MeContext = createContext(null);

/**
 * Me-State: 'idle' | 'loading' | 'ready' | 'error'.
 * Wird vom OperatorBootstrapProvider gefüttert (Fetch + Drift-Refresh).
 */
export function MeProvider({ children }) {
  const [status, setStatus] = useState('idle');
  const [me, setMeState] = useState(null);

  const setMe = useCallback((next) => setMeState(next), []);

  const value = useMemo(
    () => ({
      status,
      me,
      setMe,
      setStatus,
      permissions: me?.permissions ?? [],
    }),
    [status, me, setMe],
  );

  return <MeContext.Provider value={value}>{children}</MeContext.Provider>;
}

export function useMe() {
  const ctx = useContext(MeContext);
  if (!ctx) throw new Error('useMe must be used inside <MeProvider>');
  return ctx;
}
